import { SAVE_BUTTON_CONFIG } from "../../../../../constants/button";
import { ASSIGN_CLIENT_BUTTON_CONSTANT } from "../../../../../constants/translate-messages/button";
import { ButtonConfig } from "../../../../../models/common/forms/button";
import { clientSelectControl, locationSelectControl } from "../../../../../constants/form-control/employee/assign-location";
import { FormControlUtil } from "../../../../../core/utils/form-control";
import { NoRecordFound, NoRecordType } from "../../../../../models/common/table/table-config";
import { EMPLOYEE_MESSAGES } from "../../../../../constants/no-record-found/employee";

/**
 * This constant used for Assign Client Form
 */
 export const ASSIGN_CLIENT_FORM_CONTROLS = {
  client: FormControlUtil.mergeFormControl(clientSelectControl, { key: 'client' }),
  location: FormControlUtil.mergeFormControl(locationSelectControl, { key : 'location'}),
};

/**
 * Button config
 */
 export const CUSTOM_SAVE_BUTTON_CONFIG: ButtonConfig = FormControlUtil.mergeFormControl(
  SAVE_BUTTON_CONFIG,
  {
    options: FormControlUtil.mergeFormControl(SAVE_BUTTON_CONFIG.options, {
      text: ASSIGN_CLIENT_BUTTON_CONSTANT.TEXT,
    }),
  },
);

export const noRecordFound: NoRecordFound = {
  type: NoRecordType.BASIC,
  title: EMPLOYEE_MESSAGES.ASSIGN_CLIENT_NO_RECORD_TITLE,
  message: '',
  show: true,
  iconSVG: 'assets/media/iq-svg/animation/Employee/assign_timesheet.json',
}
